import { render, staticRenderFns } from "./StrandGoalKeeperDialog.vue?vue&type=template&id=3452cbae&scoped=true"
import script from "./StrandGoalKeeperDialog.vue?vue&type=script&lang=js"
export * from "./StrandGoalKeeperDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3452cbae",
  null
  
)

export default component.exports